import PropTypes from 'prop-types';
import EventModal from 'features/EventContainer/components/EventModal';
//import ModalContent from './EditEventModalContent';
import Icon from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { connect,useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Heading from 'shared/components/Heading';
import Spreadsheet from 'shared/components/Icon/icons/Spreadsheet';
import ImportView from './ImportView';
import { notification } from 'antd';
import { ImportScheduleEntriesAction } from 'features/EventContainer/redux/actions/importScheduleEntriesAction';

const SchedulerDetailsModal = props => {
  const {
    visible,
    onCancel,
    successBack,
    panelBack,
    time_zone,
    isLoading,
    importScheduleEntries
  } = props;

  const [reset, setReset] = useState(false);
  const [isTemplateLoading, setIsTemplateLoading] = useState(false);

  const { t } = useTranslation();

  const closeModal = () => {
    onCancel();
  }

  const inviteScueessCallback = async() => { 
    successBack();
  }

  const invitePanelCallback = async() => {
    panelBack();
  }
 
    const fetchTemplateData = async (isDownloading,isResetSchedule) => {
      let data = "";
       setIsTemplateLoading(true);
      try 
      {
          data=  await importScheduleEntries(isDownloading,isResetSchedule);
          setIsTemplateLoading(false);
           return data;

      } catch (error) {
        closeModal();
        setIsTemplateLoading(false);
        console.error("Error in fetching Schedule", error);
        notification.error({
          message: 'Schedule Error',
          description: `Error fetching Schedule`,
        });
       
      }
    };

    useEffect(() => {
        if (visible) {
            // download :false, resetSchedule:false
          fetchTemplateData(false, false);
        }
      }, [visible]);

  const downloadtemplate = async () => {

    setReset(prev => !prev);

    // download :true, resetSchedule:false
    const data=await fetchTemplateData(true, false);
    await downloadCsv(data);
  }

  const downloadCsv = async (data) => {

      try {
  
        const url = window.URL.createObjectURL(new Blob([data], {
          type: "text/csv"
        }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'schedule-template.csv')
        document.body.appendChild(link)
        link.click()
      } catch (err) {
        notification.error({
          message: 'Error',
          description: err.description || err.message,
        });
      
      }    
    }

  return (
    <EventModal
      visible={visible}
      onCancel={closeModal}
    >
       <div style={isTemplateLoading ||isLoading ? { pointerEvents: 'none', opacity: 0.6 } : {}}>
        <div className='modal__title'>
          <Heading tag={2} type='primary' weight='bold'>{t('schedulerImportHeaderLabel')}</Heading>
          <a href="#" onClick={downloadtemplate} className='link'>
                <span className='modal__link'>
                  <span className='modal__link__icon'><Icon component={Spreadsheet} /></span>
                  {t('downloadCsvLinkLabel')}
                </span>
              </a>
        </div>
        <ImportView successBack={inviteScueessCallback} panelBack={invitePanelCallback}  reset={reset} />
       
      </div>
    </EventModal>
  );
};

SchedulerDetailsModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  successBack:PropTypes.func.isRequired,
  panelBack:PropTypes.func.isRequired,
  importScheduleEntries: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => {
    const { event: { eventDetails: { time_zone }, eportEventSchedule } } = state;
    const {isLoadingSchedule} = eportEventSchedule;
  
    return { time_zone,
      isLoading: isLoadingSchedule
    }
  }
  
  const mapDispatchToProps = {
    importScheduleEntries:ImportScheduleEntriesAction
  }

export default connect(mapStateToProps, mapDispatchToProps) (SchedulerDetailsModal);